<template>
<v-container>
  <CourseForm ref="CourseForm"
    @course-created="refresh"
    @course-updated="refresh"
    @course-deleted="refresh">
  </CourseForm>

  <v-data-table
    :headers="headers"
    :items="courses"
    :loading="loading"
    :search="searchTerm">
    <template v-slot:top>
      <v-container>
        <div class="d-flex justify-space-around">
          <h2>Courses</h2>
          <v-spacer></v-spacer>
          <v-btn color="primary" small dark
            @click="$refs.CourseForm.create(selectedCourseType)">
            <!-- @click="createCourse"> -->
            Create
          </v-btn>
        </div>
        <v-row>
          <v-col cols="12" md="3" offset-md="2">
            <v-text-field
              label="Search"
              prepend-icon="mdi-magnify"
              v-model="searchTerm"
              autocomplete="off"/>
          </v-col>
          
          <v-col cols="12" md="3">
            <v-select
              v-model="selectedCourseType"
              @change="refresh"
              :items="courseTypes"
              item-text="title"
              item-value="id"
              label="Type">
            </v-select>
          </v-col>
            
          <v-col cols="12" md="1">
            <v-btn class="mt-5"
              color="primary" small dark
              @click="refresh()">
              Refresh
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

    </template>

    <template v-slot:item.teacherFullname="{ item }">
      {{ item['teacher.lastname'] }}, {{ item['teacher.firstname'] }}
    </template>

    <template v-slot:item.status="{ item }">
      <v-icon v-if="item.available"
        small
        class="mr-2"
        @click="$refs.CourseForm.updateAvailable(item.id, false)">
        mdi-star
      </v-icon>
      <v-icon v-else
        small
        class="mr-2"
        @click="$refs.CourseForm.updateAvailable(item.id, true)">
        mdi-star-outline
      </v-icon>

      <v-icon v-if="item.hidden"
        small
        class="mr-2"
        @click="$refs.CourseForm.updateHidden(item.id, false)">
        mdi-eye-off
      </v-icon>
      <v-icon v-else
        small
        class="mr-2"
        @click="$refs.CourseForm.updateHidden(item.id, true)">
        mdi-eye
      </v-icon>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="$refs.CourseForm.update(item.id)">
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="$refs.CourseForm.delete(item.id)">
        mdi-delete
      </v-icon>
    </template>

  </v-data-table>
</v-container>
</template>

<script>
import Api from '../../services/api'
import CourseForm from './CourseForm'

export default {
  name: 'CourseList',
  components: { CourseForm },
  data() {
		return {
      courseTypes: [],
      courses: [],
      selectedCourseType: 2,
      loading: false,
      searchTerm: '',
      headers: [ // must be splice-cified below when adding new fields
        { text: 'ID', value: 'id' },
        { text: 'Title', value: 'title', align: 'start' },
        { text: 'Short TItle', value: 'shortTitle' },
        { text: 'Trainer', value: 'teacherFullname' },
        { text: 'Subtitle', value: 'subtitle' },
        { text: 'Slots', value: 'slots' },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
		}
  },
  created() {
    this.loading = true;
    Api.course.getAllTypes()
      .then((response) => {
        this.courseTypes = response.data;
        this.refresh();
      })
      .finally(() => { this.loading = false });
  },
	methods: {
    refresh() {
      this.loading = true;
      Api.course.getAllFromType(this.selectedCourseType)
        .then((response) => {
          this.courses = response.data;
        })
        .finally(() => { this.loading = false });
    },
	},
}
</script>